const APPLE_SCRIPT_ID = 'apple-signin-sdk';
const APPLE_CLIENT_ID = import.meta.env.VITE_APPLE_CLIENT_ID || 'com.myeztopup.web';

const PROD_REDIRECT_URI_MYEZTOPUP = 'https://myeztopup.com/auth/apple/callback';
const DEV_REDIRECT_URI_MYEZTOPUP = 'https://dev.myeztopup.com/auth/apple/callback';
const PROD_REDIRECT_URI_EZTOPUP_MM = 'https://eztopup.com.mm/auth/apple/callback';
const DEV_REDIRECT_URI_EZTOPUP_MM = 'https://dev.eztopup.com.mm/auth/apple/callback';

let hasInitializedAppleAuth = false;

export const getAppleRedirectURI = (): string => {
  const hostname = window.location.hostname.toLowerCase();

  if (hostname === 'dev.eztopup.com.mm') return DEV_REDIRECT_URI_EZTOPUP_MM;
  if (hostname === 'eztopup.com.mm' || hostname === 'www.eztopup.com.mm')
    return PROD_REDIRECT_URI_EZTOPUP_MM;
  if (hostname === 'dev.myeztopup.com') return DEV_REDIRECT_URI_MYEZTOPUP;
  if (hostname === 'myeztopup.com' || hostname === 'www.myeztopup.com')
    return PROD_REDIRECT_URI_MYEZTOPUP;

  return import.meta.env.PROD ? PROD_REDIRECT_URI_MYEZTOPUP : DEV_REDIRECT_URI_MYEZTOPUP;
};

const loadAppleSDK = async (): Promise<void> => {
  if (typeof window === 'undefined') return;
  if (window.AppleID?.auth) return;

  await new Promise<void>((resolve, reject) => {
    const existingScript = document.getElementById(APPLE_SCRIPT_ID) as HTMLScriptElement | null;
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(), { once: true });
      existingScript.addEventListener(
        'error',
        () => reject(new Error('Failed to load Apple SDK')),
        {
          once: true,
        },
      );
      return;
    }

    const script = document.createElement('script');
    script.id = APPLE_SCRIPT_ID;
    script.src =
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Apple SDK'));
    document.head.appendChild(script);
  });
};

export const initializeAppleAuth = async (): Promise<void> => {
  await loadAppleSDK();

  if (!window.AppleID?.auth?.init) {
    throw new Error('Apple Sign In SDK is unavailable');
  }

  if (hasInitializedAppleAuth) return;

  window.AppleID.auth.init({
    clientId: APPLE_CLIENT_ID,
    scope: 'name email',
    redirectURI: getAppleRedirectURI(),
    responseType: 'code id_token',
    usePopup: true,
  });

  hasInitializedAppleAuth = true;
};
